import * as React from "react";
import { GhostButton } from "@bolteu/kalep-react";
import { cx } from "../utils/cx";
function ActionButton({ action, onClick }) {
    const handleClick = React.useCallback(() => {
        onClick(action);
    }, [onClick, action]);
    return (React.createElement(GhostButton, { onClick: handleClick },
        React.createElement("div", { className: cx("flex p-2 gap-1 hover:opacity-90") },
            React.createElement("div", { className: cx("inline-block [&>svg]:block") }, action.icon),
            React.createElement("div", { className: cx("hidden md:inline-block font-semibold") }, action.label))));
}
export function ActionBar({ state, actions, isNumericId }) {
    const handleActionClick = React.useCallback((action) => {
        var _a;
        const keyArray = isNumericId
            ? [...state.selectionManager.selectedKeys].map((key) => Number(key))
            : [...state.selectionManager.selectedKeys];
        (_a = action.onClick) === null || _a === void 0 ? void 0 : _a.call(action, {
            action,
            selectedRows: keyArray,
        });
    }, [state.selectionManager.selectedKeys, isNumericId]);
    const clearSelection = React.useCallback(() => state.selectionManager.clearSelection(), [state.selectionManager]);
    if (!state.showSelectionCheckboxes || state.selectionManager.selectedKeys.size === 0) {
        return null;
    }
    return (React.createElement("div", { className: cx("sticky bottom-4 mx-10 -mt-[68px] text-center") },
        React.createElement("div", { className: cx("h-[56px] px-6 py-4 mx-auto", "inline-flex justify-start items-center gap-4", "bg-neutral-primary text-primary-inverted rounded-lg bolt-font-body-m-regular") },
            React.createElement("div", { key: "selected-count", className: cx("flex-shrink-0") },
                "Selected: ",
                state.selectionManager.selectedKeys.size),
            (actions === null || actions === void 0 ? void 0 : actions.length) && (React.createElement("div", { className: cx("flex items-center justify-start") }, actions === null || actions === void 0 ? void 0 : actions.map((action) => (React.createElement(ActionButton, { key: action.label, onClick: handleActionClick, action: action }))))),
            React.createElement(GhostButton, { onClick: clearSelection, overrideClassName: cx("ml-4 hover:opacity-90") },
                React.createElement("span", { className: cx("font-semibold") }, "Cancel")))));
}
